<input type="text" class="form-control" [value]="value" (keyup)="onValueChanged($event)" #places ngxTrim>
